import { useRef, useCallback } from "react";

/**
 * Histórico simples baseado em snapshots de "pages".
 * commit(next) aceita objeto OU função (prev => next).
 */
export default function useHistory(state, setState) {
  const past = useRef([]);
  const future = useRef([]);

  const resolveNext = useCallback(
    (nextOrFn) => (typeof nextOrFn === "function" ? nextOrFn(state) : nextOrFn),
    [state]
  );

  const commit = useCallback(
    (nextOrFn) => {
      const next = resolveNext(nextOrFn);
      past.current.push(state);
      future.current = [];
      setState(next);
    },
    [state, setState, resolveNext]
  );

  const undo = useCallback(() => {
    if (!past.current.length) return;
    const prev = past.current.pop();
    future.current.push(state);
    setState(prev);
  }, [state, setState]);

  const redo = useCallback(() => {
    if (!future.current.length) return;
    const next = future.current.pop();
    past.current.push(state);
    setState(next);
  }, [state, setState]);

  return { commit, undo, redo };
}
